import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { openDialogFn } from '@helpers';
import { ModalWrapper } from './modal-wrapper/modal-wrapper';
import type { DialogConfig, DialogResult } from '@appTypes';

@Injectable({
  providedIn: 'root',
})
export class Modals {
  private readonly openDialog = openDialogFn(inject(Dialog));

  open<T extends Record<string, unknown>, K>(
    component: ComponentType<unknown>,
    config?: DialogConfig<T> & { closeButton?: boolean; title?: string; titleIcon?: string }
  ): DialogResult<K> {
    return this.openDialog(ModalWrapper, {
      data: {
        component,
        inputs: config?.data,
        closeButton: config?.closeButton !== false,
        title: config?.title,
        titleIcon: config?.titleIcon,
      },
      backdropClass: config?.backdropClass,
      panelClass: config?.panelClass,
      easyClose: config?.easyClose,
      width: config?.width ?? '60lvw',
      minWidth: config?.minWidth,
      maxWidth: config?.maxWidth,
      height: config?.height ?? '70lvh',
      minHeight: config?.minHeight,
      maxHeight: config?.maxHeight,
    });
  }
}
